export default __webpack_public_path__ + "static/media/icon--fee03.b5228e82.svg";